'use client';

import React from 'react';

interface FormProgressProps {
  attendance: string;
}

export default function FormProgress({ attendance }: FormProgressProps) {
  const showBhopal = attendance === 'engagement' || attendance === 'both';
  const showWarud = attendance === 'wedding' || attendance === 'both';
  const showSummary = attendance && attendance !== 'neither';

  const steps = [
    { label: 'About You', always: true },
    { label: 'RSVP', always: true },
    { label: 'Bhopal Journey', always: false, show: showBhopal },
    { label: 'Bhopal Stay', always: false, show: showBhopal },
    { label: 'Free Days', always: false, show: showBhopal },
    { label: 'Bhopal → Warud', always: false, show: showWarud },
    { label: 'Warud Stay', always: false, show: showWarud },
    { label: 'After Wedding', always: false, show: showWarud },
    { label: 'Travel Summary', always: false, show: !!showSummary },
    { label: 'A Few More Things', always: true },
  ];

  const visible = steps.filter((s) => s.always || s.show);
  const totalVisible = visible.length;

  return (
    <div
      className="rounded-2xl px-5 py-4 mb-6 shadow-sm"
      style={{ backgroundColor: 'var(--card)' }}
    >
      <p
        className="text-xs font-semibold uppercase tracking-wider mb-3"
        style={{ color: 'var(--muted-foreground)' }}
      >
        {attendance
          ? `${totalVisible} sections in your RSVP`
          : 'Select attendance below to see your RSVP sections'}
      </p>

      <div className="flex flex-wrap gap-2">
        {visible.map((step, i) => (
          <span
            key={`progress-step-${i}`}
            className="text-xs px-3 py-1 rounded-full font-medium"
            style={{
              backgroundColor: 'var(--background)',
              color: 'var(--foreground)',
              border: '1px solid var(--border)',
            }}
          >
            {i + 1}. {step.label}
          </span>
        ))}
      </div>
    </div>
  );
}